export const getChatLog = (state, id) => {
  const taskChat = state.chat.task;
  const chat = taskChat.find((item) => item.id === id);
  return chat ? chat.log : [];
};
